import React, { Component } from 'react';
import { DropDownMenu } from 'material-ui';

const styles = {
  dropdown: {
    verticalAlign: 'top',
    fontSize: '16px'
  },
  label: {
    lineHeight: '56px',
    display: 'inline-block',
    verticalAlign: 'top',
    fontWeight: 700
  },
  menuItem: {
    fontSize: '16px'
  }
};

export default class DropDown extends Component {
  getStyle() {
    return {
      display: this.props.fullWidth ? 'block' : 'inline-block'
    };
  }

  render() {
    let { label, ...other } = this.props;
    return (
      <div style={this.getStyle()}>
        <div style={styles.label}>{label}</div>
        <DropDownMenu
          labelStyle={styles.dropdown}
          menuItemStyle={styles.menuItem}
          style={styles.dropdown}
          {...other}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/DropDown.js